import {
  GET_MERCHANT_LINK_PAYMENT,
  GET_MERCHANT_LINK_PAYMENT_SUCCESS,
  GET_MERCHANT_LINK_PAYMENT_BY_GUID,
  GET_MERCHANT_LINK_PAYMENT_BY_GUID_SUCCESS,
  ADD_MERCHANT_LINK_PAYMENT,
  ADD_MERCHANT_LINK_PAYMENT_SUCCESS,
  UPDATE_MERCHANT_LINK_PAYMENT,
  UPDATE_MERCHANT_LINK_PAYMENT_SUCCESS,
  DELETE_MERCHANT_LINK_PAYMENT,
  DELETE_MERCHANT_LINK_PAYMENT_SUCCESS,
  UPDATE_MERCHANT_LINK_PAYMENT_STATUS,
  UPDATE_MERCHANT_LINK_PAYMENT_STATUS_SUCCESS,
  SHARE_MERCHANT_LINK_PAYMENT,
  SHARE_MERCHANT_LINK_PAYMENT_SUCCESS,
  MERCHANT_LINK_PAYMENT_API_ERROR,
  GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY,
  GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_SUCCESS,
  MERCHANT_LINK_DO_PAYMENT,
  MERCHANT_LINK_DO_PAYMENT_SUCCESS,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_SUCCESS,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_FAIL,
  MERCHANT_LINK_CLEAR_CHECK_BIN_ERROR,
} from "./actionTypes"


export const getMerchantLinkPayment = userName => ({
  type: GET_MERCHANT_LINK_PAYMENT,
  payload: userName,
})

export const getMerchantLinkPaymentSuccess = userName => ({
  type: GET_MERCHANT_LINK_PAYMENT_SUCCESS,
  payload: userName,
})

export const getMerchantLinkPaymentByGuid = guid => ({
  type: GET_MERCHANT_LINK_PAYMENT_BY_GUID,
  payload: guid,
})

export const getMerchantLinkPaymentByGuidSuccess = record => ({
  type: GET_MERCHANT_LINK_PAYMENT_BY_GUID_SUCCESS,
  payload: record,
})

export const addMerchantLinkPayment = record => ({
  type: ADD_MERCHANT_LINK_PAYMENT,
  payload: record,
})

export const addMerchantLinkPaymentSuccess = record => ({
  type: ADD_MERCHANT_LINK_PAYMENT_SUCCESS,
  payload: record,
})


export const updateMerchantLinkPayment = record => ({
  type: UPDATE_MERCHANT_LINK_PAYMENT,
  payload: record,
})

export const updateMerchantLinkPaymentSuccess = record => ({
  type: UPDATE_MERCHANT_LINK_PAYMENT_SUCCESS,
  payload: record,
})

export const updateMerchantLinkPaymentStatus = record => ({
  type: UPDATE_MERCHANT_LINK_PAYMENT_STATUS,
  payload: record,
})

export const updateMerchantLinkPaymentStatusSuccess = guid => ({
  type: UPDATE_MERCHANT_LINK_PAYMENT_STATUS_SUCCESS,
  payload: guid,
})

export const deleteMerchantLinkPayment = guid => ({
  type: DELETE_MERCHANT_LINK_PAYMENT,
  payload: guid,
})

export const deleteMerchantLinkPaymentSuccess = guid => ({
  type: DELETE_MERCHANT_LINK_PAYMENT_SUCCESS,
  payload: guid,
})

export const shareMerchantLinkPayment = record => ({
  type: SHARE_MERCHANT_LINK_PAYMENT,
  payload: record,
})

export const shareMerchantLinkPaymentSuccess = record => ({
  type: SHARE_MERCHANT_LINK_PAYMENT_SUCCESS,
  payload: record,
})

export const getMerchantLinkPaymentSpesificByKey = record => ({
  type: GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY,
  payload: record,
})

export const getMerchantLinkPaymentSpesificByKeySuccess = record => ({
  type: GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_SUCCESS,
  payload: record
})

export const merchantLinkDoPayment = record => ({
  type: MERCHANT_LINK_DO_PAYMENT,
  payload: record,
})

export const merchantLinkDoPaymentSuccess = record => ({
  type: MERCHANT_LINK_DO_PAYMENT_SUCCESS,
  payload: record,
})

export const merchantLinkCheckBinCardNumber = record => ({
  type: MERCHANT_LINK_CHECK_BIN_CARD_NUMBER,
  payload: record,
})

export const merchantLinkCheckBinCardNumberSuccess = record => ({
  type: MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_SUCCESS,
  payload: record,
})

export const merchantLinkCheckBinCardNumberFail = error => ({
  type: MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_FAIL,
  payload: error,
})

export const clearMerchantLinkCheckBinError = () => ({
  type: MERCHANT_LINK_CLEAR_CHECK_BIN_ERROR,
})

export const merchantLinkPaymentError = error => {
  return {
    type: MERCHANT_LINK_PAYMENT_API_ERROR,
    payload: error,
  }
}

